type CleanHrefOptions = {
  href: string;
  siteBasePath: string;
};

/**
 * Adds the site base path to the href.
 * Also removes trailing slashes to avoid Next redirecting (e.g. /gb/ -> /gb)
 **/
export const cleanHrefWithSiteBasePath = ({
  href,
  siteBasePath,
}: CleanHrefOptions): string => {
  const url = new URL(href, "http://dummy-base");
  const pathname = url.pathname.replace(/\/$/, "");
  return `${siteBasePath}${pathname}${url.search}${url.hash}`;
};
